module.exports = __webpack_public_path__ + "static/media/15UN-Habitat1.000a30a8.jpg";